module.exports = __webpack_public_path__ + "bb53dedcc526b187f846837f12126618.svg";